(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tyresme-offer-slideshow"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(scope) {
    scope.querySelectorAll('[data-offer-slider]').forEach(slider => {
      if(slider.dataset.ready) return;
      slider.dataset.ready = 'true';
      const track = slider.querySelector('.tm-offer-slider__track');
      function move(direction) {
        const slides = [...track.children];
        const width = track.clientWidth + 20;
        const index = Math.round(track.scrollLeft / width);
        const next = (index + direction + slides.length) % slides.length;
        track.scrollTo({left:next * width,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      }
      slider.querySelector('[data-prev]')?.addEventListener('click',()=>move(-1));
      slider.querySelector('[data-next]')?.addEventListener('click',()=>move(1));
      track.addEventListener('keydown',event=>{if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();move(event.key==='ArrowRight'?1:-1);}});
    });
  }
  init(document);
  document.addEventListener('shopify:section:load',()=>init(document));
  document.addEventListener('shopify:block:select',event=>{const slide=event.target.closest('.tm-offer-slider__slide');if(slide)slide.scrollIntoView({block:'nearest',inline:'start'});});
})();

  } catch(e) { console.error(e); }
})();
})();
